import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, SimpleListAdapter, TS_Checkbox, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import './Editor_SmartDocParam.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { ResourceTypes, variableType_Attribute, variableType_Normal, variableType_PrecipitatingFactor, variableType_RelievingFactor } from '@app/hcs-shared';
import { DropDown_ContextRule, DropDown_Tag, DropDown_VariableV3, ModuleFE_ContextRule, ModuleFE_Tag, ModuleFE_Variable, } from '@app/hcs-frontend';
import { smartDocParamResolverLabelMap, smartDocParamType_Static, smartDocStaticParamType_Attribute, smartDocStaticParamType_ChiefComplaint, smartDocStaticParamType_ContextRule, smartDocStaticParamType_Factor, smartDocStaticParamType_Finding, smartDocStaticParamType_MDM, smartDocStaticParamType_MDM_ConsiderationGroup_LabelMap, smartDocStaticParamType_MDM_ConsiderationGroups, smartDocStaticParamType_MDM_ProtocolStatus, smartDocStaticParamType_MDM_ProtocolStatus_LabelMap, smartDocStaticParamType_MDM_ProtocolType_LabelMap, smartDocStaticParamType_MDM_ProtocolTypes, smartDocStaticParamType_Orders, smartDocStaticParamType_Orders_Statuses, smartDocStaticParamType_Orders_Statuses_LabelMap, smartDocStaticParamType_Orders_SubType_LabelMap, smartDocStaticParamType_Orders_SubTypes, smartDocStaticParamType_PhysicianNotes, smartDocStaticParamType_SmartMDM, smartDocStaticParamType_Tag, smartDocStaticParamType_Template, smartDocStaticParamType_Time, smartDocStaticParamTypeLabelMap, } from '@app/advisor-content-shared';
import { DropDown_SmartDocParamSubType } from '../DropDown_SmartDocParamSubType.js';
import { DropDown_ParamResolver_Variable } from '../../smart-doc-param-resolver/DropDown_ParamResolver_Variable.js';
import { DropDown_ParamResolver_Template } from '../../smart-doc-param-resolver/DropDown_ParamResolver_Template.js';
import { viewMode_Edit, viewMode_View } from '@app/styles';
import { DropDown_ParamResolver_Orders } from '../../smart-doc-param-resolver/DropDown_ParamResolver_Orders.js';
import { DropDown_ParamResolver_PhysicianNotes } from '../../smart-doc-param-resolver/DropDown_ParamResolver_PhysicianNotes.js';
import { DropDown_ParamResolver_MDM } from '../../smart-doc-param-resolver/DropDown_ParamResolver_MDM.js';
import { DropDown_ParamResolver_Time } from '../../smart-doc-param-resolver/DropDown_ParamResolver_Time.js';
import { ModuleFE_LogTemplate } from '../../../_entity/log-tempalte/index.js';
import { DropDown_LogTemplate } from '../../../_entity/log-tempalte/ui-components.js';
export class Editor_SmartDocParam_Static extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        state.params = nextProps.params;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getParentKeyAdapter = (excludeKey) => {
        const options = this.state.params.filter(param => param.key !== excludeKey
            && param.type === smartDocParamType_Static
            && (param.subType === smartDocStaticParamType_Finding || param.subType === smartDocStaticParamType_ChiefComplaint)).map(param => param.key);
        return SimpleListAdapter(options, item => _jsx(_Fragment, { children: item.item }));
    };
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_SubType(), this.render_Content()] });
    }
    render_SubType = () => {
        const param = this.state.editable;
        const subType = param.item.subType ? smartDocStaticParamTypeLabelMap[param.item.subType] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "And sub type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: subType }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_SmartDocParamSubType, { editable: param, allowedParamSubTypes: this.props.allowedParamSubTypes }) }
                    ] })] });
    };
    render_Content = () => {
        const paramSubType = this.state.editable.item.subType;
        switch (paramSubType) {
            case smartDocStaticParamType_Tag:
                return this.renderTag();
            case smartDocStaticParamType_Finding:
                return this.renderFinding();
            case smartDocStaticParamType_ChiefComplaint:
                return this.renderChiefComplaint();
            case smartDocStaticParamType_Attribute:
                return this.renderAttribute();
            case smartDocStaticParamType_Factor:
                return this.renderFactor();
            case smartDocStaticParamType_Template:
                return this.renderTemplate();
            case smartDocStaticParamType_Orders:
                return this.renderOrders();
            case smartDocStaticParamType_PhysicianNotes:
                return this.renderPhysicianNotes();
            case smartDocStaticParamType_MDM:
                return this.renderMDM();
            case smartDocStaticParamType_ContextRule:
                return this.renderContextRule();
            case smartDocStaticParamType_SmartMDM:
                return this.renderSmartMDM();
            case smartDocStaticParamType_Time:
                return this.renderTime();
            default:
                return _jsx(_Fragment, {});
        }
    };
    render_ParamResolver_Variable = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_Variable, { editable: param }) }
                    ] })] });
    };
    render_ParamResolver_ChiefComplaint = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_Variable, { editable: param }) }
                    ] })] });
    };
    render_VariableSelector = (param, queryFilter) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With variable" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View, renderer: () => {
                                const variable = ModuleFE_Variable.cache.unique(param.item.id);
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: variable?.name ?? 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => _jsx(DropDown_VariableV3.editable, { editable: param, prop: 'id', limitItems: 50, caret: undefined, queryFilter: queryFilter })
                        }
                    ] })] });
    };
    render_ParamResolver_Orders = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_Orders, { editable: param }) }
                    ] })] });
    };
    render_Resolver_PhysicianNotes = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_PhysicianNotes, { editable: param }) }
                    ] })] });
    };
    render_Resolver_MDM = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_MDM, { editable: param }) }
                    ] })] });
    };
    render_Resolver_Time = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_Time, { editable: param }) }
                    ] })] });
    };
    render_ParentKey = (param) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "For parent key" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: param.item.parentKey ?? 'N/A' }) }) },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                const adapter = this.getParentKeyAdapter(param.item.key);
                                return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.parentKey, onSelected: parentKey => {
                                        param.updateObj({ parentKey: parentKey });
                                    } });
                            }
                        }
                    ] })] });
    };
    // ######################## Render - Tag Specific ########################
    renderTag = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderTag_Selector(param), this.render_ParamResolver_Variable(param)] });
    };
    renderTag_Selector = (param) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With tag" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View, renderer: () => {
                                const tag = ModuleFE_Tag.cache.unique(param.item.id);
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: tag?.label ?? 'N/A' }) });
                            }
                        },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_Tag.editable, { editable: param, prop: 'id' }) }
                    ] })] });
    };
    // ######################## Render - Finding Specific ########################
    renderFinding = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.render_VariableSelector(param, variable => variable.type === variableType_Normal), this.render_ParamResolver_Variable(param)] });
    };
    // ######################## Render - Chief Complaint Specific ########################
    renderChiefComplaint = () => {
        const param = this.state.editable;
        return _jsx(_Fragment, { children: this.render_ParamResolver_ChiefComplaint(param) });
    };
    // ######################## Render - Attribute Specific ########################
    renderAttribute = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.render_VariableSelector(param, variable => variable.type === variableType_Attribute), this.render_ParentKey(param), this.render_ParamResolver_Variable(param)] });
    };
    // ######################## Render - Factor Specific ########################
    renderFactor = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderFactor_FactorType(param), this.render_ParentKey(param), this.render_ParamResolver_Variable(param)] });
    };
    renderFactor_FactorType = (param) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With factor type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: param.item.factorType ?? 'N/A' }) }) },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                const adapter = SimpleListAdapter([variableType_RelievingFactor, variableType_PrecipitatingFactor], node => _jsx(_Fragment, { children: node.item }));
                                return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.factorType, onSelected: factorType => {
                                        param.updateObj({ factorType: factorType });
                                    } });
                            }
                        }
                    ] })] });
    };
    // ######################## Render - Template Specific ########################
    renderTemplate = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderTemplate_TemplateSelector(param), this.renderTemplate_Resolver(param)] });
    };
    renderTemplate_TemplateSelector = (param) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With smart log by template" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View, renderer: () => {
                                const doc = ModuleFE_LogTemplate.cache.unique(param.item.id);
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: doc?.label ?? 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit, renderer: () => _jsx(DropDown_LogTemplate.editable, { editable: param, prop: 'id', queryFilter: doc => this.props.filterLogTemplateId?.(doc._id) ?? true })
                        }
                    ] })] });
    };
    renderTemplate_Resolver = (param) => {
        const resolver = param.item.resolver ? smartDocParamResolverLabelMap[param.item.resolver] : 'N/A';
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: resolver }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ParamResolver_Template, { editable: param }) }
                    ] })] });
    };
    // ######################## Render - Orders Specific ########################
    renderOrders = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderOrders_OrderTypes(param), this.renderOrders_OrderStatus(param), this.renderOrders_RelatedResource(param), this.render_ParamResolver_Orders(param)] });
    };
    renderOrders_OrderTypes = (param) => {
        const orderTypes = param.editProp('orderSubtype', []);
        const updateOrderTypes = (orderType) => {
            const index = orderTypes.item.indexOf(orderType);
            if (index === -1)
                return orderTypes.updateArrayAt(orderType);
            orderTypes.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "Of order type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: orderTypes.item.map(type => smartDocStaticParamType_Orders_SubType_LabelMap[type]).join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: smartDocStaticParamType_Orders_SubTypes.map(type => {
                                        return _jsx(TS_Checkbox, { checked: orderTypes.item.includes(type), onCheck: () => updateOrderTypes(type), children: smartDocStaticParamType_Orders_SubType_LabelMap[type] }, type);
                                    }) });
                            }
                        }
                    ] })] });
    };
    renderOrders_OrderStatus = (param) => {
        const orderStatus = param.editProp('orderStatus', []);
        const updateOrderStatus = (status) => {
            const index = orderStatus.item.indexOf(status);
            if (index === -1)
                return orderStatus.updateArrayAt(status);
            orderStatus.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "and order status" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: orderStatus.item.map(status => smartDocStaticParamType_Orders_Statuses_LabelMap[status]).join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: smartDocStaticParamType_Orders_Statuses.map(status => {
                                        return _jsx(TS_Checkbox, { checked: orderStatus.item.includes(status), onCheck: () => updateOrderStatus(status), children: smartDocStaticParamType_Orders_Statuses_LabelMap[status] }, status);
                                    }) });
                            }
                        }
                    ] })] });
    };
    renderOrders_RelatedResource = (param) => {
        const relatedResource = param.editProp('relatedResource', []);
        const updateRelatedResource = (resourceType) => {
            const index = relatedResource.item.indexOf(resourceType);
            if (index === -1)
                return relatedResource.updateArrayAt(resourceType);
            relatedResource.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "and resource type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: relatedResource.item.join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: ResourceTypes.map(type => {
                                        return _jsx(TS_Checkbox, { checked: relatedResource.item.includes(type), onCheck: () => updateRelatedResource(type), children: type }, type);
                                    }) });
                            }
                        }
                    ] })] });
    };
    // ######################## Render - Physician Notes Specific ########################
    renderPhysicianNotes = () => {
        const param = this.state.editable;
        return _jsx(_Fragment, { children: this.render_Resolver_PhysicianNotes(param) });
    };
    // ######################## Render - MDM Specific ########################
    renderMDM = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderMDM_ProtocolType(param), this.renderMDM_ConsiderationGroup(param), this.renderMDM_ProtocolStatus(param), this.render_Resolver_MDM(param)] });
    };
    renderMDM_ProtocolType = (param) => {
        const protocolTypes = param.editProp('protocolType', []);
        const updateProtocolTypes = (orderType) => {
            const index = protocolTypes.item.indexOf(orderType);
            if (index === -1)
                return protocolTypes.updateArrayAt(orderType);
            protocolTypes.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "Of protocol type" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: protocolTypes.item.map(type => smartDocStaticParamType_MDM_ProtocolType_LabelMap[type]).join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: smartDocStaticParamType_MDM_ProtocolTypes.map(type => {
                                        return _jsx(TS_Checkbox, { checked: protocolTypes.item.includes(type), onCheck: () => updateProtocolTypes(type), children: smartDocStaticParamType_MDM_ProtocolType_LabelMap[type] }, type);
                                    }) });
                            }
                        }
                    ] })] });
    };
    renderMDM_ConsiderationGroup = (param) => {
        const groups = param.editProp('protocolConsiderationGroup', []);
        const updateGroups = (group) => {
            const index = groups.item.indexOf(group);
            if (index === -1)
                return groups.updateArrayAt(group);
            groups.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "And consideration group" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: groups.item.map(group => smartDocStaticParamType_MDM_ConsiderationGroup_LabelMap[group]).join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: smartDocStaticParamType_MDM_ConsiderationGroups.map(group => {
                                        return _jsx(TS_Checkbox, { checked: groups.item.includes(group), onCheck: () => updateGroups(group), children: smartDocStaticParamType_MDM_ConsiderationGroup_LabelMap[group] }, group);
                                    }) });
                            }
                        }
                    ] })] });
    };
    renderMDM_ProtocolStatus = (param) => {
        const protocolStatuses = param.editProp('protocolStatus', []);
        const updateProtocolStatus = (status) => {
            const index = protocolStatuses.item.indexOf(status);
            if (index === -1)
                return protocolStatuses.updateArrayAt(status);
            protocolStatuses.removeArrayItem(index);
        };
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "And protocol status" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => {
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: protocolStatuses.item.map(type => smartDocStaticParamType_MDM_ProtocolStatus_LabelMap[type]).join(', ') || 'N/A' }) });
                            }
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                return _jsx(LL_V_L, { className: 'editor__smart-doc-param__check-list', children: smartDocStaticParamType_MDM_ProtocolStatus.map(type => {
                                        return _jsx(TS_Checkbox, { checked: protocolStatuses.item.includes(type), onCheck: () => updateProtocolStatus(type), children: smartDocStaticParamType_MDM_ProtocolStatus_LabelMap[type] }, type);
                                    }) });
                            }
                        }
                    ] })] });
    };
    // ######################## Render - Smart MDM Specific ########################
    renderSmartMDM = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderMDM_ProtocolType(param), this.renderMDM_ConsiderationGroup(param), this.renderMDM_ProtocolStatus(param), this.render_Resolver_MDM(param)] });
    };
    // ######################## Render - Context Rule Specific ########################
    renderContextRule = () => {
        const param = this.state.editable;
        return _jsxs(_Fragment, { children: [this.renderContextRule_Selector(param), this.render_ParamResolver_Variable(param)] });
    };
    renderContextRule_Selector = (param) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: "With Context Rule" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View, renderer: () => {
                                const contextRule = ModuleFE_ContextRule.cache.unique(param.item.id);
                                return _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: contextRule?.label ?? 'N/A' }) });
                            }
                        },
                        { key: viewMode_Edit, renderer: () => _jsx(DropDown_ContextRule.editable, { editable: param, prop: 'id' }) }
                    ] })] });
    };
    // ######################## Render - Time Specific ########################
    renderTime = () => {
        const param = this.state.editable;
        return _jsx(_Fragment, { children: this.render_Resolver_Time(param) });
    };
}
//# sourceMappingURL=Editor_SmartDocParam_Static.js.map